import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config/api';

const FreeTrialForm = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/v1/trial/start`, { email, name });
      setResult(res.data);
      if (res.data.success && onSuccess) {
        onSuccess(res.data);
      }
    } catch (err) {
      setResult({ success: false, message: 'Something went wrong. Try again.' });
    } finally {
      setLoading(false);
    }
  };

  if (result?.success) {
    return (
      <div className="trial-success" data-testid="trial-success">
        <div className="success-icon">🎉</div>
        <h3>Your trial has started!</h3>
        <p>You have 14 days of full access. Check your email for details.</p>
        <p className="expires">Expires: {new Date(result.expires_at).toLocaleDateString()}</p>
      </div>
    );
  }

  return (
    <form className="trial-form" onSubmit={handleSubmit} data-testid="trial-form">
      <h3>Start Your Free Trial</h3>
      <p>14 days of Pro features. No credit card required.</p>
      
      <div className="form-group">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name (optional)"
          data-testid="trial-name"
        />
      </div>
      <div className="form-group">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          data-testid="trial-email"
        />
      </div>
      
      {result?.already_used && (
        <p className="trial-error">You've already used your free trial.</p>
      )}
      {result && !result.success && !result.already_used && (
        <p className="trial-error">{result.message}</p>
      )}
      
      <button type="submit" disabled={loading} data-testid="trial-submit">
        {loading ? 'Starting...' : 'Start Free Trial'}
      </button>
      
      <ul className="trial-features">
        <li>✓ Daily digest emails</li>
        <li>✓ Full archive access</li>
        <li>✓ API access (1000 calls)</li>
      </ul>
    </form>
  );
};

export default FreeTrialForm;
